export class SearchQueryDebouncer {

  listener!: (searchQueryUpdate: string) => void;

  constructor(listener: (searchQueryUpdate: string) => void) {
    this.listener = listener;
  }

  clearSearchQuery() {
    this.listener && this.listener("")
  }

  searchTimeout: NodeJS.Timeout | null = null;

  debounceSearch(newQuery: string) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (newQuery === "") {
      this.clearSearchQuery();
      return;
    }

    this.searchTimeout = setTimeout(() => {
      this.listener && this.listener(newQuery)
    }, 400);
  }
}
